// currently the props table is broken related issue: https://github.com/storybookjs/storybook/issues/8881
// previous fix is preventing storybook from working at all
import React, { forwardRef } from 'react';
import StyledRoundButton from './RoundButton.styles';
import { useConsumeWeaveTheme } from '../../hocs/ApplicationWrapper/theme/WeaveContext';
const RoundButton = ({ children, hoverBackgroundColor: _hoverBackgroundColor, focusBackgroundColor: _focusBackgroundColor, actionColor: _actionColor, ...other }, ref) => {
    const { resolvedRoles, isWeaveTheme } = useConsumeWeaveTheme();
    const hoverBackgroundColor = _hoverBackgroundColor ||
        (isWeaveTheme && resolvedRoles['avatarBundle.hover.backgroundColor']);
    const focusBackgroundColor = _focusBackgroundColor ||
        (isWeaveTheme && resolvedRoles['avatarBundle.hover.backgroundColor']);
    const actionColor = _actionColor ||
        (isWeaveTheme ? resolvedRoles['colorScheme.text.default'] : 'white');
    return (React.createElement(StyledRoundButton, { ref: ref, ...other, hoverBackgroundColor: hoverBackgroundColor, focusBackgroundColor: focusBackgroundColor, actionColor: actionColor }, children));
};
export default forwardRef(RoundButton);
